import Location, { Props as LocationProps } from './Location';

export type { LocationProps };
export default Location;
